// extracted by mini-css-extract-plugin
export default {"button":"ColumnSortButton_button__EpeFm","asc":"ColumnSortButton_asc__qnG0S","desc":"ColumnSortButton_desc__EM8Lw"};